import { Container, Row, Col } from 'react-bootstrap'

function SevenWaysBrain () {
	
return (
    <>
    <div className="sevenWays__Brain pt-3">
        <Container className="text-center py-5">
            <div className="sevenWays__Brain--text">
                <h3>A GOOD MEMORY IS ESSENTIAL FOR EVERYONE, IN EVERY WALK OF LIFE!</h3>
                <h4 className="py-5">In this free report you'll discover:</h4>
            </div>
            <Row>
                <Col lg={4} md={12} sm={12}>
                <img className="sevenWays__Brain--img mt-3" src="../images/7ways/img-brain04.png" alt="Brain" />
                <p className="mt-3">Warning flags that you want to recognize early so you can take action on brain health.</p>
                </Col>
                <Col lg={4} md={12} sm={12}>
                <img className="sevenWays__Brain--img mt-3" src="../images/7ways/img-brain05.png" alt="Brain" />
                <p className="mt-3">Foods to eat and nutrients that have been shown to have dramatic effects on brain health.</p>
                </Col>
                <Col lg={4} md={12} sm={12}>
                <img className="sevenWays__Brain--img mt-3" src="../images/7ways/img-brain05.png" alt="Brain" />
                <p className="mt-3">Simple tips and strategies to improve your memory within just days.</p>
                </Col>
            </Row>
        </Container>
    </div>
    <style jsx>{`
            .sevenWays__Brain{
            background: #FFF;
            }
            h3{
                color: #47d9bf;
                font-weight: 500px;
            }
            `}
        </style>
    </>
);
}
export default SevenWaysBrain;